import styled from '@emotion/styled';

export const Background = styled.div`
    background-color: ${(props) => props.theme.palette.background.paper};
    border-radius: ${(props) => props.theme.shape.radius.default};
    border: 1px solid ${(props) => props.theme.palette.divider};

    padding: ${(props) => props.theme.spacing.xs};

    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: ${(props) => props.theme.spacing.sm};

    position: relative;
`;

export const StyledInput = styled.input`
    width: 100%;
    background-color: transparent;
    font: ${(props) => props.theme.fonts.subtitle4};

    ::-webkit-input-placeholder {
        /* Edge */
        color: ${(props) => props.theme.palette.text.secondary};
        overflow-wrap: break-word;
        word-break: break-all;
        text-overflow: ellipsis;
    }

    :-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: ${(props) => props.theme.palette.text.secondary};
        overflow-wrap: break-word;
        word-break: break-all;
        text-overflow: ellipsis;
    }

    ::placeholder {
        color: ${(props) => props.theme.palette.text.secondary};
        overflow-wrap: break-word;
        word-break: break-all;
        text-overflow: ellipsis;
    }
`;
